import { render, staticRenderFns } from "./GridCampaignUpdated.vue?vue&type=template&id=ffa68730&scoped=true&"
import script from "./GridCampaignUpdated.vue?vue&type=script&lang=js&"
export * from "./GridCampaignUpdated.vue?vue&type=script&lang=js&"
import style0 from "./GridCampaignUpdated.vue?vue&type=style&index=0&id=ffa68730&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa68730",
  null
  
)

export default component.exports